import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { PerformanceSummary } from '@/hooks/usePartnerAnalytics';
import { Badge } from '@/components/ui/badge';
import { FileText } from 'lucide-react';

interface PendingDocumentsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contractors: PerformanceSummary[];
}

export function PendingDocumentsDialog({ open, onOpenChange, contractors }: PendingDocumentsDialogProps) {
  const withPending = contractors.filter(c => c.pending_documents > 0);
  const totalPending = withPending.reduce((sum, c) => sum + c.pending_documents, 0);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle>
            Pending Documents ({totalPending} total)
          </DialogTitle>
        </DialogHeader>

        <div className="overflow-auto flex-1">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Contractor</TableHead>
                <TableHead>Type</TableHead>
                <TableHead className="text-right">Pending</TableHead>
                <TableHead className="text-right">Verified</TableHead>
                <TableHead className="text-right">Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {withPending.map((contractor) => (
                <TableRow key={contractor.id}>
                  <TableCell className="font-medium">
                    <div className="flex items-center gap-2">
                      <FileText className="h-4 w-4 text-muted-foreground" />
                      {contractor.name}
                    </div>
                  </TableCell>
                  <TableCell className="capitalize">{contractor.company_type}</TableCell>
                  <TableCell className="text-right">
                    <Badge variant="secondary">{contractor.pending_documents}</Badge>
                  </TableCell>
                  <TableCell className="text-right text-muted-foreground">
                    {contractor.verified_documents}
                  </TableCell>
                  <TableCell className="text-right text-muted-foreground">
                    {contractor.total_documents}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
